<template>		
	<div>		
		<div v-if="!pedido.proveedor.standalone && !pedido.cancelado" :class="[requiereSurtir(pedido) ? ( pedido.surtido ? 'border border-primary text-primary' : 'border border-yellow-500 text-yellow-500') : 'border text-gray-300 border-gray-300']" class="rounded-full text-center py-1 px-2">
			<p class="whitespace-nowrap">{{ requiereSurtir(pedido) ? ( pedido.surtido ? "Surtido" : "Pendiente") : "No requiere"}}</p>
		</div>

		<router-link
			v-if="pedido.proveedor.standalone && !pedido.cancelado && currentCollection"
			:to="collectionLink"
			:class="collectionPillStyle"
			class="block rounded-full text-center py-1 px-2"
		>
			<p class="whitespace-nowrap">Recolección</p>
		</router-link>

		<div v-else-if="pedido.proveedor.standalone && !pedido.cancelado" class="rounded-full text-center py-1 px-2 border text-gray-300 border-gray-300">
			<p class="whitespace-nowrap">No requiere</p>
		</div>

	</div>
</template>

<script>
	import { computed } from 'vue'
	import { utils } from '../utils/utils.js'
	import { getCurrentOrderCollection } from '../utils/recolecciones.js'

	export default {
		props: ['pedido', 'user'],

		setup(props) {
			const currentCollection = computed(() => getCurrentOrderCollection(props.pedido))
			const collectionPillStyle = computed(() => currentCollection.value?.estado === 'recibida'
				? 'border border-primary text-primary'
				: 'border border-yellow-500 text-yellow-500'
			)
			const collectionLink = computed(() => {
				if (!currentCollection.value) return ''

				return props.user === 'admin'
					? `/admin/recolecciones/${currentCollection.value.id}`
					: `/proveedor/${props.pedido.proveedor.id}/recolecciones/${currentCollection.value.id}`
			})

			function requiereSurtir() {
				return utils.requireEntregaSurtir(props.pedido).surtir
			}

			return {
				requiereSurtir,
				currentCollection,
				collectionLink,
				collectionPillStyle
			}
		}
	}
</script>
